/**
 * Constants related to the supported deep link actions.
 */

/**
 * Open the payment dialog once the sale has been loaded.
 */
export const PAY = 'pay'

/**
 * Close the webRegister tab once the sale has been completed
 */
export const VEND_API_LOAD_SALE_CLOSE_AFTER_COMPLETE =
  'VEND_API_LOAD_SALE_CLOSE_AFTER_COMPLETE'
